/**
 * «Origem da lead» — obrigatória no passo 1 dos três assistentes. Sem nada
 * escolhido por omissão; Referência de Cliente e Lead empresa pedem um texto
 * (vai para «Referido por» na lead do Odoo).
 */
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select"
import { LEAD_ORIGINS, leadOriginOption, type LeadOriginValue } from "@/lib/lead-origin"

export function LeadOriginField({
  value, onChange,
}: {
  value: LeadOriginValue
  onChange: (next: LeadOriginValue) => void
}) {
  const option = leadOriginOption(value.lead_origin)
  const missing = !option
  const missingDetail = !!option?.ask && !value.lead_origin_detail.trim()
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
      <div className="space-y-1">
        <Label required>Origem da lead</Label>
        <Select
          value={value.lead_origin ?? ""}
          onValueChange={(v) => onChange({ lead_origin: v, lead_origin_detail: leadOriginOption(v)?.ask ? value.lead_origin_detail : "" })}
        >
          <SelectTrigger aria-invalid={missing} className={missing ? "border-amber-500" : undefined}>
            <SelectValue placeholder="Escolha a origem…" />
          </SelectTrigger>
          <SelectContent>
            {LEAD_ORIGINS.map((o) => (
              <SelectItem key={o.key} value={o.key}>{o.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        {missing && <p className="text-xs text-amber-700 dark:text-amber-400">Obrigatória — fica registada na lead do Odoo.</p>}
      </div>
      {option?.ask && (
        <div className="space-y-1">
          <Label required>{option.ask}</Label>
          <Input
            value={value.lead_origin_detail}
            aria-invalid={missingDetail}
            className={missingDetail ? "border-amber-500" : undefined}
            placeholder={option.key === "lead_empresa" ? "Ex.: ligou na loja, email da empresa…" : "Nome do cliente"}
            onChange={(e) => onChange({ ...value, lead_origin_detail: e.target.value })}
          />
        </div>
      )}
    </div>
  )
}
